import { useState, useEffect } from "react";
import { getTokenExpirationDate } from "../utils/jwtUtils";
import getCookie from "../utils/cookieUtils";

export function useAuth() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const isLoggedInFromStorage = localStorage.getItem("isLoggedIn");
    return isLoggedInFromStorage ? JSON.parse(isLoggedInFromStorage) : false;
  });

  const logout = () => {
    document.cookie = `token=; Secure; SameSite=Strict; path=/; max-age=0`;
    localStorage.removeItem("isLoggedIn");
    sessionStorage.setItem('logout_reason', 'session_expired');
    setIsLoggedIn(false);
    window.location.href = '/login';
  };

  return { isLoggedIn, setIsLoggedIn, logout };
}